export interface TermData {
  type: string
  title: string
}

export interface DestinationOption {
  id: string
  title: string
  linkUrl: string
  linkText: string
  linkRel?: string
  location: string
  termData?: TermData[]
  onClick: () => void
}

export const US_TOP_DESTINATIONS_CARDS = [
  {
    id: '_xV0eNZqFSo',
    thumb: '/v1628872119/arizona-video-block-thumbnail.png',
    description:
      'Enjoy beautiful natural scenery and treatment from experienced providers.',
    location: 'Arizona',
    slug: '/arizona/'
  },
  {
    id: 'wOhhWoqqGwM',
    thumb: '/v1628872162/colorado-video-block-thumbnail.png',
    description:
      'Experience quality treatment with awe-inspiring views in naturally beautiful settings.',
    location: 'Colorado',
    slug: '/colorado/'
  },
  {
    id: 'YZlY2oitaKI',
    thumb: '/v1722356470/john-bFcy5Ldv6kM-unsplash.jpg',
    description:
      'Sunshine, beaches, and warm climate attract clients seeking treatment through wellness and rejuvenation',
    location: 'Florida',
    slug: '/florida/'
  }
]

export const INTERNATIONAL_TOP_DESTINATIONS_CARDS = [
  {
    id: '7knKtfMkbHk',
    thumb: '/v1628872144/bali-video-block-thumbnail.png',
    description:
      'Recovery hub with beautiful landscapes, culture, and spiritual focus.',
    location: 'Bali',
    slug: '/bali/'
  },
  {
    id: 'SE_DLvgUP-Q',
    thumb: '/v1667937331/destinations-south-africa-background.jpg',
    description:
      'Discover high-quality, affordable treatment amid natural beauty and diverse activities.',
    location: 'South Africa',
    slug: '/south-africa/'
  },
  {
    id: 'B2hz4l3GRBY',
    thumb: '/v1667937459/destinations-switzerland-background.jpg',
    description:
      'Find stunning views, utmost privacy, and elite individualized treatment.',
    location: 'Switzerland',
    slug: '/switzerland/'
  }
]
